// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-1f8fea50],.fade-leave-active[data-v-1f8fea50]{transition:opacity 0.5s}.fade-enter[data-v-1f8fea50],.fade-leave-to[data-v-1f8fea50]{opacity:0}\n", ""]);
// Exports
module.exports = exports;
